export default import.meta.ROLLDOWN_FILE_URL_JGaMnWYqo0Fg4JxB$LTbaA